import * as React from 'react';
import { useContext } from 'react';

import type { TrackingData } from 'js/lib/retracked';

// For each page context, holds eventing metadata that will be applied to every event.
// For example, in enterprise page we will attach program info.
const EventingMetadataContext = React.createContext<TrackingData>({});

export const useEventingMetadata = () => {
  const eventingMetadata = useContext(EventingMetadataContext);

  return eventingMetadata;
};

export default EventingMetadataContext;
